



import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CREATE_CALL_URl, DELETE_CALL_URl, GET_Calls_HISTORY_URl, GET_Calls_URl, MANAGE_Calls_VIEW_HISTORY_LOG_URl, MANAGE_Calls_VIEW_HISTORY_URl, UPDATE_CALL_URl, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllCall = createAsyncThunk('getCalls', async (body, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_Calls_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllCallSlice = createSlice({
    name: 'Call',
    initialState: {
        AllCall: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllCall.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllCall.fulfilled, (state, action) => {
                state.AllCall = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllCall.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const GetCallDetialsSlice = createSlice({
    name: 'Call Details ',
    initialState: {
        Call: ''
    },
    reducers: {
        setCallDetials: (state, action) => {
            state.Call = action.payload;
        }
    }
});

export const CreateCall = createAsyncThunk('CreateCall', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_CALL_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return {status : response?.status}
        }
    } catch (err) { console.log(err, 'dd');
    
        return err
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateCall = createAsyncThunk('updatemenu', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_CALL_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return {status : response?.status}
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const ManageCallHistoryView = createAsyncThunk('CallHistoryView', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(MANAGE_Calls_VIEW_HISTORY_URl, { CallsManageID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            // Toast('success', response?.data?.apiStatus?.statusMessage)
            
            let { data } = response.data
            // console.log(data);
            return { status: 200, viewers : data }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const ManageCallHistoryLog = createAsyncThunk('ManageCallLog', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(MANAGE_Calls_VIEW_HISTORY_LOG_URl, { CallsManageID: body });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteCall = createAsyncThunk('deletMenu', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_CALL_URl, { CallsManageID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            // Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Async Thunk to Get User Profile --
export const GetCallHistory = createAsyncThunk('getHistory', async (body, { rejectWithValue }) => {
    console.log(body);

    try {
        const response = await FetchData(GET_Calls_HISTORY_URl, { CallsManageID: body });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});



// -- Slice --
const GetCallHistorySlice = createSlice({
    name: 'Call History',
    initialState: {
        CallHistory: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetCallHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetCallHistory.fulfilled, (state, action) => {
                state.CallHistory = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetCallHistory.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});




export const { setCallDetials } = GetCallDetialsSlice.actions
export {
    GetAllCallSlice,
    GetCallDetialsSlice,
    GetCallHistorySlice
};
